import { Environment } from "./environment.interface";

declare const Drupal: any;

let apiHost = Drupal.settings?.apiHost;
if (!apiHost) {
    apiHost = !Drupal.settings.isDevelopment ? "https://api.eslgaming.com" : "https://api.int.pinc.esl.systems";
}

export const environment: Environment = {
    production: true,
    drupalProduction: !Drupal.settings.isDevelopment,
    apiHost: apiHost,
};
